// extracted by mini-css-extract-plugin
export var banner = "GameConceptTlaBanner-module__banner___9Gy+w";
export var content = "GameConceptTlaBanner-module__content___huYke";
export var icon = "GameConceptTlaBanner-module__icon___Tak+b";
export var subtitle = "GameConceptTlaBanner-module__subtitle___Yuv71";
export var title = "GameConceptTlaBanner-module__title___xLoje";